.wrapper {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 9000;
}

.button {
  width: 44px;
  height: 44px;
  background: transparent;
  border: none;
  padding: 0;
  color: var(--color-text-muted);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color var(--duration-fast);
}

.button:hover {
  color: var(--neon-cyan);
}

.panel {
  position: absolute;
  bottom: 56px;
  right: 0;
  width: 280px;
  padding: 24px;
  border-radius: var(--radius-lg);
  background: var(--color-bg-secondary);
  border: 1px solid var(--color-border-default);
  backdrop-filter: var(--glass-blur);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.5);
}

.panelTitle {
  font-family: var(--font-heading);
  font-weight: 700;
  font-size: 15px;
  color: var(--color-text-primary);
  margin-bottom: 12px;
}

.panelText {
  font-family: var(--font-body);
  font-size: 13px;
  line-height: 1.6;
  color: var(--color-text-secondary);
  margin: 0;
}

.panelLink {
  display: inline-block;
  margin-top: 12px;
  font-family: var(--font-body);
  font-size: 13px;
  font-weight: 600;
  color: var(--neon-cyan);
  text-decoration: none;
  transition: opacity var(--duration-fast);
}

.panelLink:hover {
  opacity: 0.7;
}

@media (max-width: 768px) {
  .wrapper {
    bottom: 16px;
    right: 16px;
  }

  .panel {
    width: calc(100vw - 48px);
    max-width: 280px;
    right: 0;
  }
}
